import React from 'react'
import CircularProgress from '@material-ui/core/CircularProgress'

const LoadingIndicator = ({
  label = 'Loading',
  style,
  labelStyle,
  ...props
}) => {
  return (
    <section
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column',
        width: '100%',
        height: '100%',
        maxHeight: '100vh',
        padding: '8px',
        ...style,
      }}
    >
      <CircularProgress {...props} />
      <span
        style={{
          marginTop: '12px',
          ...labelStyle,
        }}
      >
        {label}
      </span>
    </section>
  )
}

export default LoadingIndicator



// WEBPACK FOOTER //
// ./src/Components/LoadingIndicator/LoadingIndicator.js